import { LuChevronDown } from "react-icons/lu";
import { motion } from "framer-motion";

const categories = [
  { name: "스시", emoji: "🍣" },
  { name: "베이커리", emoji: "🥐" },
  { name: "포케 · 샐러드", emoji: "🥗" },
  { name: "도시락 (한식)", emoji: "🍚" },
  { name: "반찬", emoji: "🍱" },
  { name: "떡", emoji: "🍡" },
  { name: "구내식당", emoji: "🏫" },
];

export function CategorySection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="h-screen snap-start flex flex-col bg-white px-5 py-12">
      <motion.div
        className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          variants={itemVariants}
          className="text-center mb-8"
          style={{ fontSize: "2.25rem", fontWeight: 800, lineHeight: 1.3 }}
        >
          이미 다양한 업종이
          <br />
          함께하고 있어요
        </motion.h1>

        <motion.div
          variants={itemVariants}
          className="w-full bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl overflow-hidden shadow-xl mb-6"
        >
          <div className="p-4">
            <div className="grid grid-cols-2 gap-3">
              {categories.map((category, index) => (
                <div
                  key={index}
                  className="bg-white backdrop-blur-sm rounded-2xl p-4 hover:bg-white/30 transition-colors flex flex-col items-center justify-center aspect-[1.2/1]"
                >
                  <div className="text-4xl mb-2">{category.emoji}</div>
                  <p
                    className="text-center break-keep"
                    style={{ fontSize: "1rem", fontWeight: 700 }}
                  >
                    {category.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants}>
          <LuChevronDown className="w-6 h-6 text-gray-400 animate-bounce" />
        </motion.div>
      </motion.div>
    </section>
  );
}
